import { render } from "./SignUpView.vue?vue&type=template&id=8f0d879a&ts=true"
import script from "./SignUpView.vue?vue&type=script&lang=ts"
export * from "./SignUpView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__